import CryptoJS from "crypto-js";
export const decryptToken=(encryptedData, secretKey) =>{
    // Parse the encrypted data from JSON
    const data = JSON.parse(encryptedData);
    const encryptedToken = data.encryptedToken;
    const ivBase64 = data.iv;

    //// Convert the secret key to a WordArray and pad to ensure it is 32 bytes long
    const key = CryptoJS.enc.Utf8.parse(secretKey.padEnd(32, ' '));

    // Decode the IV from Base64 to WordArray
    const ivBytes = CryptoJS.enc.Base64.parse(ivBase64);

    // Decrypt the token using AES with the provided IV
    const decrypted = CryptoJS.AES.decrypt(encryptedToken, key, {
        iv: ivBytes,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7,
    });

    // Convert decrypted data to a UTF-8 string
    return decrypted.toString(CryptoJS.enc.Utf8);
}